'use strict';

var $ = require('jquery');

function init() {
	// Search open and close
	var $searchIcon = $('.search-icon'),
		$searchArea = $('.search-area');

	$searchIcon.on('click', function(){
		$searchArea.toggleClass('open');
		if ( $searchArea.hasClass('open') ){
			$searchArea.find('.search-form-input input').focus();
		}
	});

	// Mobile Menu bar animations
	var $window = $(window),
		$triggers = $('.menuTriggers, .footer__donateButton'),
		$menuTitle = $('.mobile-menu-title');

	$window.scroll(function(){
		var scrollTop = $window.scrollTop();

		if (scrollTop >= 120){
			$triggers.addClass('scrolled');
		} else {
			$triggers.removeClass('scrolled');
		}

		if (scrollTop >= 145){
			$menuTitle.addClass('active');
		} else {
			$menuTitle.removeClass('active');
		}
	});
}
module.exports = {
	init : init
};
